import ChildAccountReporting from './ChildAccountReporting';

export default ChildAccountReporting;
